// GENERATED FILE -- DO NOT EDIT BY HAND.
//
// Source of truth: techladder-core/app/domain/rbac/permissions.py
// Regenerate:      python scripts/export_permissions.py
//                  (or `npm run generate:permissions` from this repo)
//
// The category ids below are the ones the API gates on
// (RequirePermission -> get_permission_category -> org entitlements), so the
// grouping here must match the backend's, not whatever reads best in the UI.


export const PERMISSION_CATEGORIES = [
  {
    id: "agents",
    label: "Agents",
    permissions: [
      { id: "agents.view", label: "View agent list and configs" },
      { id: "agents.create", label: "Create new agents" },
      { id: "agents.edit", label: "Edit prompts, settings, versions" },
      { id: "agents.delete", label: "Delete agents" },
      { id: "agents.folders.manage", label: "Create/rename/delete folders" },
    ],
  },
  {
    id: "workflows",
    label: "Workflows",
    permissions: [
      { id: "workflows.view", label: "View workflows and runs" },
      { id: "workflows.create", label: "Create workflows" },
      { id: "workflows.edit", label: "Edit and publish workflows" },
      { id: "workflows.delete", label: "Delete workflows" },
    ],
  },
  {
    id: "calls",
    label: "Calls",
    permissions: [
      { id: "calls.history", label: "View call logs" },
      { id: "calls.recordings.view", label: "Play recordings" },
      { id: "calls.recordings.download", label: "Download recordings" },
      { id: "calls.test", label: "Make test calls" },
    ],
  },
  {
    id: "schedules",
    label: "Schedules",
    permissions: [
      { id: "schedules.view", label: "View scheduled batches" },
      { id: "schedules.create", label: "Create/schedule batch calls" },
      { id: "schedules.manage", label: "Pause, resume, cancel batches" },
    ],
  },
  {
    id: "callbacks",
    label: "Callbacks",
    permissions: [
      { id: "callbacks.view", label: "View callbacks" },
      { id: "callbacks.manage", label: "Create, update, cancel callbacks" },
    ],
  },
  {
    id: "contacts",
    label: "Contacts",
    permissions: [
      { id: "contacts.view", label: "View contact lists" },
      { id: "contacts.manage", label: "Upload, edit, delete contacts" },
    ],
  },
  {
    id: "analytics",
    label: "Analytics",
    permissions: [
      { id: "analytics.view", label: "View dashboards and charts" },
      { id: "analytics.export", label: "Export data as CSV" },
    ],
  },
  {
    id: "billing",
    label: "Billing",
    permissions: [
      { id: "billing.view", label: "View credit balances" },
      { id: "billing.manage", label: "Add credits, update payment" },
    ],
  },
  {
    id: "team",
    label: "Team",
    permissions: [
      { id: "team.view", label: "View team members" },
      { id: "team.invite", label: "Send invitations" },
      { id: "team.manage", label: "Change roles, remove members" },
    ],
  },
  {
    id: "settings",
    label: "Settings",
    permissions: [
      { id: "settings.general", label: "General account settings" },
    ],
  },
  {
    id: "voice",
    label: "Voice",
    permissions: [
      { id: "settings.voice", label: "Voice model preferences" },
    ],
  },
  {
    id: "voice_cloning",
    label: "Voice Cloning",
    permissions: [
      { id: "voice.clone", label: "Clone a voice from a recording" },
    ],
  },
  {
    id: "api",
    label: "API",
    permissions: [
      { id: "api.keys.view", label: "View API keys" },
      { id: "api.keys.manage", label: "Create, revoke API keys" },
    ],
  },
  {
    id: "webhooks",
    label: "Webhooks",
    permissions: [
      { id: "webhooks.view", label: "View webhook endpoints" },
      { id: "webhooks.manage", label: "Create, edit, delete webhooks" },
    ],
  },
  {
    id: "campaigns",
    label: "Campaigns",
    permissions: [
      { id: "campaigns.view", label: "View campaigns" },
      { id: "campaigns.manage", label: "Create and run campaigns" },
    ],
  },
  {
    id: "timeliner",
    label: "Timeliner",
    permissions: [
      { id: "timeliner.access", label: "Call timeliner feature" },
    ],
  },
  {
    id: "ask",
    label: "Ask",
    permissions: [
      { id: "ask.access", label: "AI 'Ask' feature" },
    ],
  },
  {
    id: "chatbot",
    label: "Chatbot",
    permissions: [
      { id: "chatbot.access", label: "Access the chatbot feature" },
    ],
  },
  {
    id: "whatsapp",
    label: "WhatsApp",
    permissions: [
      { id: "whatsapp.chats.view", label: "View WhatsApp chats (My Chat)" },
      { id: "whatsapp.chats.reply", label: "Reply to WhatsApp chats and take over from AI" },
      { id: "whatsapp.templates.view", label: "View WhatsApp templates" },
      { id: "whatsapp.templates.manage", label: "Create, edit and delete WhatsApp templates" },
      { id: "whatsapp.campaigns.view", label: "View WhatsApp campaigns" },
      { id: "whatsapp.campaigns.manage", label: "Create and launch WhatsApp campaigns" },
    ],
  },
  {
    id: "supervision",
    label: "Supervision",
    permissions: [
      { id: "supervision.view", label: "Watch live calls and transcripts" },
      { id: "supervision.guide", label: "Send guidance to the AI mid-call" },
      { id: "supervision.listen", label: "Join a live call and hear the customer" },
      { id: "supervision.takeover", label: "Take over a call and speak to the customer" },
      { id: "supervision.triage", label: "Acknowledge and dismiss live-call alerts" },
      { id: "supervision.rules.manage", label: "Configure and publish supervision alert rules" },
    ],
  },
  {
    id: "crm",
    label: "CRM",
    permissions: [
      { id: "crm.access", label: "Open the CRM and work own leads" },
      { id: "crm.leads.view_all", label: "See every lead, not just assigned ones" },
      { id: "crm.leads.edit", label: "Edit lead details" },
      { id: "crm.leads.delete", label: "Delete leads" },
      { id: "crm.leads.assign", label: "Assign and reassign leads" },
      { id: "crm.manage", label: "Manage campaigns, rules, SLA and reports" },
    ],
  },
  {
    id: "call_analytics",
    label: "Call Analytics",
    permissions: [
      { id: "call_analytics.view", label: "View call analytics results" },
      { id: "call_analytics.configure", label: "Configure call analytics features, sampling and scorecards" },
    ],
  },
];
